module.exports = __webpack_public_path__ + "static/service-section01-img-sp-0819b737922266d2755e646d44040d5f.png";